import { createContext, useContext, useState, useEffect } from "react";
import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../contexts/auth-context";
import Icon from "../atoms/Icon";
import fullLogo from "../../assets/logo_1x.png";
import smallLogo from "../../assets/queues_icon.svg";
import { getChanges } from "../../util";
import moment from "moment";
import Changes from "../../changes.json"
import { getUserTeam } from "../../util.js";
import BallparkIcon from "../../assets/bp_logo_white.svg"

export const LoadingContext = createContext();
export const ThemeContext = createContext();

export default function Nav() {
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("queues-theme") || "light"
  );
  const navigate = useNavigate();
  const location = useLocation();
  const latestVersion = Changes[0].versionName;

  var links = [
    {
      url: "locations",
      icon: "geo-fill",
      label: "Locations",
    },
    ...(authCtx.league === 'mlb' ? [{
      url: "ballpark",
      customIcon: BallparkIcon,
      // icon: "x-diamond-fill",
      label: "Ballpark",
    }] : []),
    
    {
      url: "analytics",
      icon: "pie-chart-fill",
      label: "Analytics",
    },
    // Fan View: Titans only, the same rule as its route (TitansRoute in App.js)
    ...(authCtx.venue === 'titansNFL' ? [{
      url: "fanview",
      icon: "phone",
      label: "Fan View",
    }] : []),
  ];

  const logout = () => {
    authCtx.logout();
    navigate("/auth");
  };

  useEffect(() => {
    localStorage.setItem("queues-theme", theme);
    // document.documentElement.setAttribute("data-theme", theme);
    // We are forcing light mode for now 12/13/24
    localStorage.setItem("queues-theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
  }, [theme]);

  // Log out automatically if token expires during active session
  useEffect(() => {
    authCtx.loggedIn &&
      moment.unix(authCtx.tokenExpirationTime) < moment(new Date()) &&
      logout();
  }, [location.pathname]);

  useEffect(() => {
    location.pathname === "/" &&
      navigate(authCtx.loggedIn ? "/locations" : "/auth");
  }, [location.pathname]);

  return (
    <>
      <div className={"modal modal-lg"} id="changes">
        <div className="modal-dialog">
          <div className="modal-content p-3 elevated-card-2">
            <div className="p-4">
              {getChanges("").map((x, index) => (
                <div className="mb-5" key={index}>
                  <p className="h3" >
                    {/* v{x.versionName} ({x.date}) */}
                    v{x.versionName}
                  </p>
                  <hr  />
                  <div className="mt-3">
                    {x.changes.map((y, yIndex) => (
                      <div className="d-flex mb-1" key={yIndex}>
                        <Icon name="dot"  />
                        <span className="badge mx-2">{y.type}</span>
                        <span >{y.description}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <LoadingContext.Provider value={[loading, setLoading]}>
        <div className="nav-main d-flex flex-column vh-100">
          <div className="container flex-grow-1 d-flex flex-column">
            <Link
              to="/locations"
              style={{ color: "#53b8aa" }}
              className="logo mb-4">
              <img
                alt="Full Logo"
                src={fullLogo}
                className="nav-logo-img full-logo"
              />
              <img
                alt="Small Logo"
                src={smallLogo}
                className="nav-logo-img small-logo"
              />
            </Link>

            <div className="flex-grow-1 d-flex flex-column">
              {authCtx.loggedIn && (
                <>
                  <div className="nav-links mb-4">
                  {links.map((link) => (
                    <Link
                      key={link.label}
                      className={`nav-item-custom nav-btn`}
                      to={"/" + link.url}>
                      {link.customIcon ? (
                        <img src={link.customIcon} alt="" style={{ width: "2em", height: "2em" }} />
                      ) : (
                        <Icon name={link.icon} style={{ fontSize: "1.2em", marginLeft: "0.2em", marginRight: "0.4em" }} />
                      )}
                      <span className="nav-label">{link.label}</span>
                    </Link>
                  ))}
                  </div>
                  
                  <div className="mt-auto">
                    {authCtx.loggedIn ? (
                      <>
                        <Link
                          className="nav-item-custom nav-btn w-100"
                          to={"/account"}>
                          <Icon name="person-fill" style={{ fontSize: "1.1em", marginLeft: "0.0em", marginRight: "0.4em" }} />
                          <span className="nav-label">{authCtx.firstName}</span>
                        </Link>
                      </>
                    ) : (
                      <Link to="/auth" className="btn w-100 mb-3">
                        <Icon name="person-fill" style={{ fontSize: "1.1em", marginLeft: "0.3em", marginRight: "0.4em" }} />
                        <span className="nav-label">Log In</span>
                      </Link>
                    )}
                    <hr />
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={"mailto:support@queues.com?subject=" + getUserTeam(authCtx.league, authCtx.venue).name + " Support - v" + latestVersion}                      
                      className="nav-item-custom nav-btn w-100">
                      <Icon name="question-circle" style={{ fontSize: "1.1em", marginLeft: "0.0em", marginRight: "0.4em" }}/>
                      <span className="nav-label">Support</span>
                    </a>
                    <a
                      type="button"
                      data-bs-target="#changes"
                      data-bs-toggle="modal"
                      className="nav-item-custom nav-btn w-100 mt-3">
                      <Icon name="asterisk" style={{ fontSize: "1.2em", marginLeft: "0.0em", marginRight: "0.4em" }}/>
                      <span className="nav-label">Changelog</span>
                    </a>
                    <div className="mb-3"></div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <ThemeContext.Provider value={[theme, setTheme]}>
          {location.pathname !== "/" ? (
            <Outlet />
          ) : (
            <div className="d-flex vh-100 ">
              <div className="m-auto opacity-25">
                <img alt="Full Logo" src={fullLogo} className="" />
              </div>
            </div>
          )}
        </ThemeContext.Provider>
      </LoadingContext.Provider>
    </>
  );
}